import velocity from 'velocity-animate';

export default class OpenAnimation {
  constructor() {
    this.pl = document.getElementById('PhotoList');


    this.displayOn();
  }

  displayOn() {
    this.pl.style.opacity = 0

    Velocity(this.pl,
      {
        opacity: 1
      },
      {
        duration: 2400,
        ease: 'easeOutExpo',
        complete: () =>{
          this.pl.classList.add('is-animation');
          setTimeout( () => {
            this.pl.classList.add('animation-on');
          }, 4000)
          setTimeout( () => {
            document.getElementById('LoadTop').style.display = 'none';
          }, 7600)
        }
      }
    );

  }

}



// WEBPACK FOOTER //
// ./src/assets/js/components/OpenAnimation.js